/**
 * Created by nchaturvedi on 7/25/17.
 */
import uuid from 'node-uuid';
export const USER_SESSION_ID = 'userSessionId';

export function setUserSessionId() {
    sessionStorage.setItem(USER_SESSION_ID, uuid.v4());
}

export function getUserSessionId() {
    return sessionStorage.getItem(USER_SESSION_ID);
}

export function clearUserSessionId() {
    sessionStorage.removeItem(USER_SESSION_ID);
}

export function getSessionStorageKey(sessionStorageKey) {
    return sessionStorage.getItem(sessionStorageKey);
}

export function setSessionStorageKey(sessionStorageKey, sessionStorageValue) {
    try {
        sessionStorage.setItem(sessionStorageKey, sessionStorageValue);
    } catch (e) {
        console.log('session storage is not supported by browser');
    }
}



// WEBPACK FOOTER //
// ./src/app-lib/helpers/SessionStorageHelper.js